import { gql } from '@apollo/client'

export const GET_GROUP_COMPONENTS = gql`
  query GET_GROUP_COMPONENTS(
    $groupId: Int!
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [AdditionalComponentOrderByWithRelationInput!]
  ) {
    findManyAdditionalComponent(
      where: {
        additionalComponentGroupId: { equals: $groupId }
        OR: [
          { code: { mode: insensitive, contains: $searchTerm } }
          {
            additional_component_profiles: {
              some: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
        ]
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      component_sku
      image {
        src_thumbnail
      }
      additional_component_profiles {
        name
        language
      }
      _count {
        additional_component_to_advanced_product
      }
    }
  }
`

export const GET_GROUP_COMPONENTS_COUNT = gql`
  query GET_GROUP_COMPONENTS_COUNT($groupId: Int!, $searchTerm: String) {
    findManyAdditionalComponentCount(
      where: {
        additionalComponentGroupId: { equals: $groupId }
        OR: [
          { code: { mode: insensitive, contains: $searchTerm } }
          {
            additional_component_profiles: {
              some: { name: { mode: insensitive, contains: $searchTerm } }
            }
          }
        ]
      }
    )
  }
`

// Guarded backend delete (types-modified/AdditionalComponentDelete.ts): clears
// product links + prices in one transaction, refuses when an order/offer line
// still references the component. The generated deleteOne is denyAll.
export const DELETE_ADDITIONAL_COMPONENT = gql`
  mutation DELETE_ADDITIONAL_COMPONENT($id: Int!) {
    deleteSingleAdditionalComponent(id: $id) {
      id
      code
      deletedComponents
      removedComponentProductLinks
      detachedCartItems
    }
  }
`

export const GET_ADDITIONAL_COMPONENT_USAGE = gql`
  query GET_ADDITIONAL_COMPONENT_USAGE($id: Int!) {
    additionalComponentUsage(id: $id) {
      id
      code
      productCount
      componentCount
      orderLineCount
      offerLineCount
      cartLineCount
      blocked
    }
  }
`

export const CREATE_ADDITIONAL_COMPONENT_IN_GROUP = gql`
  mutation CREATE_ADDITIONAL_COMPONENT_IN_GROUP(
    $groupId: Int!
    $code: String!
    $component_sku: String
  ) {
    createOneAdditionalComponent(
      data: {
        code: $code
        component_sku: $component_sku
        additional_component_group: { connect: { id: $groupId } }
      }
    ) {
      id
      code
      component_sku
    }
  }
`
